export default "__VITE_ASSET__CqDT2PYa__"